'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Renders an error message with role="alert" and
 * aria-live="polite" so async error appearance is announced by assistive
 * technology. Linked into the control's aria-describedby chain via FieldContext.
 */
export function FieldError({ children }) {
    const ctx = useFieldContext();
    return (_jsx("span", { id: ctx?.errorId, role: "alert", "aria-live": "polite", style: { font: 'var(--type-caption)', color: 'var(--destructive)' }, children: children }));
}
//# sourceMappingURL=FieldError.js.map